import React from 'react';
import { useCurrentEditor } from '@tiptap/react';
import ToolbarDropdown from '@/components/TiptapEditor/Toolbar/Dropdowns/ToolbarDropdown';
import { DEFAULT_LINE_HEIGHT, LINE_HEIGHTS } from '../Extensions/LineHeight';

const fields = LINE_HEIGHTS.map((value) => ({
	label: value === '1' ? 'Single' : value === '2' ? 'Double' : value,
	value,
	type: 'lineHeight',
	default: DEFAULT_LINE_HEIGHT,
}));

const ToolbarLineHeightSelect = () => {
	const { editor } = useCurrentEditor();

	const paragraphHeight = editor?.getAttributes('paragraph')?.lineHeight;
	const headingHeight = editor?.getAttributes('heading')?.lineHeight;
	const activeLineHeight = headingHeight || paragraphHeight || DEFAULT_LINE_HEIGHT;

	return (
		<ToolbarDropdown
			title='Line spacing'
			showSelection={true}
			defaultValue={activeLineHeight}
			fields={fields}
			onChange={(e) => {
				const value = e.target.value;
				editor.chain().focus().setLineHeight(value).run();
			}}
			sx={{
				width: '110px',
			}}
		/>
	);
};

export default ToolbarLineHeightSelect;
